import React from 'react';
import { PriceRoundingContainer } from './PriceRoundingContainer';
import { PriceRoundingRuleMemberHeader } from '@retail/rounding/components';

export const PriceRoundingMemberContainer: React.FC = () => {
  return (
    <PriceRoundingContainer
      renderConfigEntryHeading={(ruleSetConfig) => (
        <PriceRoundingRuleMemberHeader ruleSetConfig={ruleSetConfig} />
      )}
    />
  );
};
